// Repair Form JavaScript
// Håndterer reparationsaftale formular med dynamisk bil-detaljer visning

(function () {
// @ts-nocheck
"use strict";

  // Local state
  let carBrands = [];
  let isSubmitting = false;

  // Fetch last submission date for repair form
  async function fetchLastSubmission() {
    const token = localStorage.getItem("carclub_token");
    if (!token) return null;

    try {
      const response = await fetch("/api/contact/last-repair-submission", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();
        return data.lastSubmissionDate;
      }
    } catch (error) {
      console.error("Error fetching last repair submission:", error);
    }
    return null;
  }

  // Display last submission indicator
  function displayLastSubmissionIndicator(lastDate) {
    if (!lastDate) return;

    const indicator = document.querySelector(
      '.last-submission-indicator[data-form-type="repair"]'
    );
    if (!indicator) return;

    const dateSpan = indicator.querySelector(".submission-date");
    if (dateSpan) {
      const date = new Date(lastDate);
      const danishMonths = [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec",
      ];
      const formatted = `${date.getDate()}. ${
        danishMonths[date.getMonth()]
      } ${date.getFullYear()}`;
      dateSpan.textContent = `Sidste indsendelse: ${formatted}`;
    }
    indicator.style.display = "flex";
  }

  // Load car brands from API
  async function loadCarBrands() {
    try {
      const response = await fetch(
        "https://bilhandel.dk/api/Search/SearchBrandAttributes"
      );
      carBrands = await response.json();

      // Populate dropdown
      const brandSelect = document.getElementById("repairFormCarBrand");
      if (brandSelect && carBrands.length > 0) {
        carBrands.forEach((brand) => {
          const option = document.createElement("option");
          option.value = brand.value;
          option.textContent = brand.label;
          brandSelect.appendChild(option);
        });
      }
    } catch (error) {
      // Silent error - failed to load car brands
    }
  }

  // Toggle car details section based on checkbox
  function toggleCarDetails() {
    const checkbox = document.getElementById("repairFormNoLicensePlate");
    const carDetailsSection = document.getElementById(
      "repairFormCarDetailsSection"
    );
    const licensePlateInput = document.getElementById("repairFormLicensePlate");
    const licensePlateError = document.getElementById(
      "error-repairFormLicensePlate"
    );

    if (!checkbox || !carDetailsSection || !licensePlateInput) {
      return;
    }

    if (checkbox.checked) {
      // Vis bil detaljer
      carDetailsSection.style.display = "block";
      licensePlateInput.value = "";
      licensePlateInput.disabled = true;
      licensePlateInput.required = false;
      if (licensePlateError) {
        licensePlateError.textContent = "";
      }

      // Gør bil detaljer required
      makeCarDetailsRequired(true);
    } else {
      // Skjul bil detaljer
      carDetailsSection.style.display = "none";
      licensePlateInput.disabled = false;
      licensePlateInput.required = false;

      // Fjern required fra bil detaljer
      makeCarDetailsRequired(false);
      clearCarDetailsErrors();
    }
  }

  // Make car detail fields required or not
  function makeCarDetailsRequired(required) {
    const fields = [
      "repairFormCarBrand",
      "repairFormCarModel",
      "repairFormHorsePower",
      "repairFormFirstRegistrationDate",
      "repairFormMileage",
    ];

    fields.forEach((fieldId) => {
      const field = document.getElementById(fieldId);
      if (field) {
        field.required = required;
      }
    });
  }

  // Clear car details errors
  function clearCarDetailsErrors() {
    const errorIds = [
      "error-repairFormCarBrand",
      "error-repairFormCarModel",
      "error-repairFormHorsePower",
      "error-repairFormFirstRegistrationDate",
      "error-repairFormMileage",
    ];

    errorIds.forEach((id) => {
      const errorElement = document.getElementById(id);
      if (errorElement) {
        errorElement.textContent = "";
      }
    });
  }

  // Validate single field
  function validateField(field) {
    const errorElement = document.getElementById(`error-${field.id}`);
    if (!errorElement) return true;

    errorElement.textContent = "";

    if (field.required && !field.value.trim()) {
      errorElement.textContent = "Dette felt er påkrævet";
      return false;
    }

    if (field.type === "email" && field.value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(field.value)) {
        errorElement.textContent = "Indtast en gyldig email adresse";
        return false;
      }
    }

    if (field.type === "tel" && field.value) {
      const phoneRegex = /^\d{8}$/;
      if (!phoneRegex.test(field.value.replace(/\s/g, ""))) {
        errorElement.textContent = "Indtast et gyldigt 8-cifret telefonnummer";
        return false;
      }
    }

    if (field.type === "number" && field.value) {
      if (parseInt(field.value) < 0) {
        errorElement.textContent = "Værdien skal være positiv";
        return false;
      }
    }

    return true;
  }

  // Validate radio group
  function validateRadioGroup(name, errorId) {
    const radios = document.getElementsByName(name);
    const errorElement = document.getElementById(errorId);
    if (!errorElement) return true;

    errorElement.textContent = "";

    const isChecked = Array.from(radios).some((radio) => radio.checked);
    if (!isChecked) {
      errorElement.textContent = "Vælg venligst en mulighed";
      return false;
    }

    return true;
  }

  // Validate entire form
  function validateForm() {
    let isValid = true;

    // Validate basis felter
    const requiredFields = [
      "repairFormName",
      "repairFormPhone",
      "repairFormEmail",
    ];
    requiredFields.forEach((fieldId) => {
      const field = document.getElementById(fieldId);
      if (field && !validateField(field)) {
        isValid = false;
      }
    });

    const checkbox = document.getElementById("repairFormNoLicensePlate");
    const licensePlate = document.getElementById("repairFormLicensePlate");
    const licensePlateError = document.getElementById(
      "error-repairFormLicensePlate"
    );

    if (!checkbox.checked) {
      // Hvis checkbox IKKE er markeret, skal NUMMERPLADE være påkrævet
      if (!licensePlate.value.trim()) {
        licensePlateError.textContent =
          "Indtast nummerplade eller marker 'Jeg har ikke nummerplade endnu'";
        isValid = false;
      }
    } else {
      // Hvis checkbox ER markeret, skal BILDETALJER være påkrævet
      const carDetailFields = [
        "repairFormCarBrand",
        "repairFormCarModel",
        "repairFormHorsePower",
        "repairFormFirstRegistrationDate",
        "repairFormMileage",
      ];

      carDetailFields.forEach((fieldId) => {
        const field = document.getElementById(fieldId);
        if (field && !validateField(field)) {
          isValid = false;
        }
      });
    }

    // Validate payment type radio group
    if (
      !validateRadioGroup(
        "repairFormPaymentType",
        "error-repairFormPaymentType"
      )
    ) {
      isValid = false;
    }

    // Valider email permission (altid påkrævet)
    const emailPermissionCheckbox = document.getElementById(
      "repairFormEmailPermission"
    );
    const emailPermissionError = document.getElementById(
      "error-repairFormEmailPermission"
    );

    if (!emailPermissionCheckbox?.checked) {
      if (emailPermissionError) {
        emailPermissionError.textContent =
          "Du skal acceptere at modtage email kommunikation";
        emailPermissionError.style.display = "block";
      }
      isValid = false;
    }

    // Valider marketing consent hvis Car Club er valgt
    const isCarClubCheckbox = document.getElementById("repairFormIsCarClub");
    const hasMarketingConsentCheckbox = document.getElementById(
      "repairFormHasMarketingConsent"
    );
    const marketingConsentError = document.getElementById(
      "error-repairFormHasMarketingConsent"
    );

    if (isCarClubCheckbox?.checked && !hasMarketingConsentCheckbox?.checked) {
      if (marketingConsentError) {
        marketingConsentError.textContent =
          "Du skal acceptere betingelserne for at blive medlem af Car Club";
        marketingConsentError.style.display = "block";
      }
      isValid = false;
    }

    return isValid;
  }

  // Get form data
  function getFormData() {
    const checkbox = document.getElementById("repairFormNoLicensePlate");

    const formData = {
      name: document.getElementById("repairFormName").value.trim(),
      phone: document.getElementById("repairFormPhone").value.trim(),
      email: document.getElementById("repairFormEmail").value.trim(),
    };

    // Payment type
    const paymentType = document.querySelector(
      'input[name="repairFormPaymentType"]:checked'
    );
    if (paymentType) {
      formData.isMonthlyPayment = paymentType.value === "monthly";
    }

    if (!checkbox.checked) {
      // Brug nummerplade
      const licensePlate = document
        .getElementById("repairFormLicensePlate")
        .value.trim();
      if (licensePlate) {
        formData.licensePlate = licensePlate;
      }
    } else {
      // Brug bil detaljer
      formData.carBrand = document.getElementById("repairFormCarBrand").value;
      formData.carModel = document
        .getElementById("repairFormCarModel")
        .value.trim();

      const horsePower = document.getElementById("repairFormHorsePower").value;
      if (horsePower) {
        formData.horsePower = parseInt(horsePower);
      }

      const firstRegDate = document.getElementById(
        "repairFormFirstRegistrationDate"
      ).value;
      if (firstRegDate) {
        formData.firstRegistrationDate = firstRegDate;
      }

      const mileage = document.getElementById("repairFormMileage").value;
      if (mileage) {
        formData.mileage = parseInt(mileage);
      }
    }

    // Car Club medlemskab
    const isCarClubCheckbox = document.getElementById("repairFormIsCarClub");
    const hasMarketingConsentCheckbox = document.getElementById(
      "repairFormHasMarketingConsent"
    );

    formData.isCarClub = isCarClubCheckbox?.checked || false;
    formData.hasMarketingConsent =
      hasMarketingConsentCheckbox?.checked || false;

    return formData;
  }

  // Show loading state
  function showLoading(show) {
    const submitBtn = document.getElementById("repairFormSubmitBtn");
    const submitText = document.getElementById("repairFormSubmitText");
    const loadingText = document.getElementById("repairFormLoadingText");

    if (show) {
      submitBtn.disabled = true;
      submitText.style.display = "none";
      loadingText.style.display = "inline";
    } else {
      submitBtn.disabled = false;
      submitText.style.display = "inline";
      loadingText.style.display = "none";
    }
  }

  // Show success message
  function showSuccessMessage() {
    const form = document.getElementById("repairForm");
    const successMessage = document.getElementById("repairFormSuccessMessage");

    form.style.display = "none";
    successMessage.style.display = "block";
  }

  // Show error message
  function showErrorMessage(message) {
    alert(message || "Der opstod en fejl. Prøv venligst igen.");
  }

  // Handle form submission
  async function handleSubmit(event) {
    event.preventDefault();

    if (isSubmitting) return;

    if (!validateForm()) {
      return;
    }

    isSubmitting = true;
    showLoading(true);

    try {
      const formData = getFormData();

      const headers = {
        "Content-Type": "application/json",
      };

      // Add Authorization header if user is logged in
      const token = localStorage.getItem("carclub_token");
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await fetch("/api/contact/repair-agreement", {
        method: "POST",
        headers: headers,
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        showSuccessMessage();
      } else {
        const errorData = await response.json().catch(() => ({}));
        showErrorMessage(
          errorData.message || "Der opstod en fejl. Prøv venligst igen."
        );
      }
    } catch (error) {
      showErrorMessage("Der opstod en fejl. Prøv venligst igen.");
    } finally {
      isSubmitting = false;
      showLoading(false);
    }
  }

  // Initialize function
  // Helper function to check if user is logged in
  function isLoggedIn() {
    return !!localStorage.getItem("carclub_token");
  }

  // Setup modal triggers
  function setupModalTriggers() {
    const triggerBox = document.getElementById("repairFormTrigger");
    const modalElement = document.getElementById("repairFormModal");

    if (!triggerBox || !modalElement) {
      return;
    }

    const formModal = new bootstrap.Modal(modalElement);

    // Click event på trigger box - åbn modal direkte (ingen login check)
    triggerBox.addEventListener("click", function () {
      prefillFormDataIfLoggedIn();
      hideCarClubSectionIfLoggedIn();
      formModal.show();
    });
  }

  // Prefill form data hvis bruger er logget ind
  function prefillFormDataIfLoggedIn() {
    if (!isLoggedIn()) {
      return;
    }

    try {
      const userData = JSON.parse(localStorage.getItem("carclub_user") || "{}");

      const nameField = document.getElementById("repairFormName");
      const emailField = document.getElementById("repairFormEmail");
      const phoneField = document.getElementById("repairFormPhone");

      if (nameField && userData.name) {
        nameField.value = userData.name;
      }
      if (emailField && userData.email) {
        emailField.value = userData.email;
      }
      if (phoneField && userData.phone) {
        phoneField.value = userData.phone;
      }
    } catch (error) {
      // Silent error - failed to prefill data
    }
  }

  // Skjul Car Club sektion hvis bruger er logget ind
  function hideCarClubSectionIfLoggedIn() {
    const isLoggedInUser = isLoggedIn();
    const carClubSection = document.getElementById("repairFormCarClubSection");

    if (carClubSection) {
      carClubSection.style.display = isLoggedInUser ? "none" : "block";
    }
  }

  // Toggle marketing consent sektion
  window.toggleMarketingConsent = function (formPrefix) {
    const isCarClub = document.getElementById(
      `${formPrefix}IsCarClub`
    )?.checked;
    const consentSection = document.getElementById(
      `${formPrefix}MarketingConsentSection`
    );
    const consentCheckbox = document.getElementById(
      `${formPrefix}HasMarketingConsent`
    );

    if (!consentSection || !consentCheckbox) return;

    if (isCarClub) {
      consentSection.style.display = "block";
      consentCheckbox.required = true;
    } else {
      consentSection.style.display = "none";
      consentCheckbox.required = false;
      consentCheckbox.checked = false;

      // Clear error
      const errorElement = document.getElementById(
        `error-${formPrefix}HasMarketingConsent`
      );
      if (errorElement) {
        errorElement.textContent = "";
      }
    }
  };

  // Clear marketing consent error when checkbox is checked
  window.clearMarketingConsentError = function (formPrefix) {
    const errorElement = document.getElementById(
      `error-${formPrefix}HasMarketingConsent`
    );
    if (errorElement) {
      errorElement.textContent = "";
    }
  };

  async function initializeRepairForm() {
    // Setup modal triggers
    setupModalTriggers();

    // Load car brands
    loadCarBrands();

    // Fetch and display last submission
    const lastDate = await fetchLastSubmission();
    if (lastDate) {
      displayLastSubmissionIndicator(lastDate);
    }

    // Setup checkbox listener
    const checkbox = document.getElementById("repairFormNoLicensePlate");
    if (checkbox) {
      checkbox.addEventListener("change", toggleCarDetails);
    }

    // Setup form submission
    const form = document.getElementById("repairForm");
    if (form) {
      form.addEventListener("submit", handleSubmit);
    }

    // Setup field validation on blur
    const fields = document.querySelectorAll(".tjekleasing-form-input");
    fields.forEach((field) => {
      if (field.type !== "radio" && field.type !== "checkbox") {
        field.addEventListener("blur", function () {
          validateField(this);
        });
      }
    });

    // Setup radio button validation for payment type
    const paymentRadios = document.getElementsByName("repairFormPaymentType");
    paymentRadios.forEach((radio) => {
      radio.addEventListener("change", function () {
        validateRadioGroup(
          "repairFormPaymentType",
          "error-repairFormPaymentType"
        );
      });
    });
  }

  // Initialize on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeRepairForm);
  } else {
    // DOM is already loaded
    initializeRepairForm();
  }
})();

// Global function to clear email permission error
window.clearEmailPermissionError = function (formPrefix) {
  const errorElement = document.getElementById(
    `error-${formPrefix}EmailPermission`
  );
  if (errorElement) {
    errorElement.textContent = "";
    errorElement.style.display = "none";
  }
};
